import _ from 'lodash'

const motorAdData = (ad) => {
  const output =
    _.findIndex(ad.partnerPlacements, (o) => o.id === 'sbm_insurance') !== -1 ? true : undefined
  if (output === undefined) {
    return null
  }

  return {
    sbmInsurance: output,
  }
}

export default motorAdData
